import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import icons from '@ep/images/icons';
import theme from '@ep/theme';
import { NavItem } from '@ep/types/menuData';
import ExpansionPanelDetails from '@mui/material/AccordionDetails';
import React from 'react';

export interface SubmenuProps {
  menu: NavItem;
  toggleDrawer: () => void;
}

const StyledIconLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;

  > svg {
    width: 2.25rem;
    height: 2.25rem;
  }

  :hover {
    text-decoration: none;
  }
`;

const Texts = styled.span`
  margin-left: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: ${theme.typography.toRem(12)};
  line-height: ${theme.typography.toRem(16)};
`;

const Label = styled.span`
  font-weight: bold;
`;

const StyledLink = styled(Link)`
  color: ${theme.colors.white};
  padding: 0.75rem 1.5rem;
  font-size: ${theme.typography.toRem(16)};
  line-height: ${theme.typography.toRem(22)};

  :hover {
    text-decoration: none;
  }
`;

const SubMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

function Submenu({ menu, toggleDrawer }: SubmenuProps) {
  return (
    <ExpansionPanelDetails>
      <SubMenuContainer>
        {menu.submenu?.map(submenu => {
          const Icon =
            submenu.icon && icons[submenu.icon as keyof typeof icons];

          return Icon ? (
            <StyledIconLink
              key={submenu.label}
              to={submenu.link}
              onClick={toggleDrawer}
            >
              <Icon />
              <Texts>
                <Label>{submenu.label}</Label>
                <span>{submenu.description}</span>
              </Texts>
            </StyledIconLink>
          ) : (
            <StyledLink
              key={submenu.label}
              to={submenu.link}
              onClick={toggleDrawer}
            >
              {submenu.label}
            </StyledLink>
          );
        })}
      </SubMenuContainer>
    </ExpansionPanelDetails>
  );
}

export default Submenu;
